import css from '@components/Registration/StepHeader.module.css'
import { PictogramType, Typography } from '@internations/ds'
import clsx from 'clsx'
import { HTMLAttributes, ReactElement } from 'react'

type StepHeaderProps = {
    Pictogram: PictogramType
    heading: string
    caption?: string
} & HTMLAttributes<HTMLDivElement>

export default function StepHeader({ Pictogram, heading, caption, className, ...rest }: StepHeaderProps): ReactElement {
    return (
        <div {...rest} className={clsx(css.root, className)}>
            <Pictogram className={css.pictogram} />
            <div className={clsx('text-center sm:text-left', css.textWrapper)}>
                <Typography variant="h2">{heading}</Typography>
                {caption ? (
                    <Typography variant="body2" className="color-text-secondary">
                        {caption}
                    </Typography>
                ) : null}
            </div>
        </div>
    )
}
